import Container from "@components/Container";
import Logo from "@components/Logo";
import styles from "./Privacy.module.scss";

const Privacy = (): JSX.Element => (
    <Container>
        <div className={styles.container}>
            <Logo />
            <div>
                <h1>PRIVACY POLICY</h1>
                <p>Effective date: July 22nd, 2021</p>
                <p>
                    Home Hobby Solutions, LLC (“The Rocket Factory”, "us", "we", or "our") operates the{" "}
                    <a href="https://www.tomsachsrocketfactory.com">www.tomsachsrocketfactory.com</a> website
                    (the"Service").
                </p>
                <p>
                    This page informs you of our policies regarding the collection, use and disclosure of personal data
                    when you use our Service and the choices you have associated with that data.
                </p>
                <p>
                    We use your data to provide and improve the Service. By using the Service, you agree to the
                    collection and use of information in accordance with this policy. Unless otherwise defined in this
                    Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and
                    Conditions, accessible from{" "}
                    <a href="https://www.tomsachsrocketfactory.com">www.tomsachsrocketfactory.com</a>
                </p>
                <h4>Information Collection And Use:</h4>
                <p>
                    The only personal data related to you that we store is your digital wallet address and the digital
                    signature of Terms of Use and Privacy Policy. Optionally email and nickname can be provided by the
                    user and stored in the database. In most cases refusal to provide the reliable information will lead
                    to an inability to provide necessary services to you. Personal data related to you cannot be used
                    without your consent. But we also have the right to use the personal data without your consent in
                    order to perform the contract (agreement) with you, to fulfill lawful governmental requirements, as
                    well as in other cases expressly permitted by applicable law.
                </p>
                <p>
                    We undertake to ensure the safe processing of personal data and avoidance of unauthorized access,
                    deletion or modification of such personal data. The above-mentioned measures must comply with the
                    existing level of technological development and shall be applied taking into account the degree of
                    harm that may be caused to you in case of unauthorized access, deletion or modification of personal
                    data, but in any event, such measures should be not lower than the requirements of the applicable
                    legislation.
                </p>
                <p>
                    We do not collect any payment-related information about you, except for your publicly available
                    Ethereum wallet address. We use your digital wallet address signature to execute the purchase. We do
                    not collect any other personally identifiable information about you unless you contact us directly
                    via email, application form or social network. In some cases, some other information might be
                    accessible to us, including such information which is necessary to identify the payer in the
                    specific payment system, to solve claims of the subject or other entities, some other technical
                    information, including IP and software used for access to the websites or online services.
                    Processing of your personal data shall mean any action (operation) or a combination of actions
                    (operations) carried out with personal data including collection, recording, systematization,
                    accumulation, storage, adjustment (update, change), extraction, use, transfer (distribution,
                    assignment, access), depersonalization, blocking, deletion, destruction.
                </p>
                <h4>Types of Data Collected:</h4>
                <h5>Personal Data</h5>
                <p>
                    While using our Service, we may ask you to provide us with certain personally identifiable
                    information that can be used to contact or identify you ("Personal Data"). Personally identifiable
                    information may include, but is not limited to:
                    <ul>
                        <li>Ethereum wallet address</li>
                        <li>Cookies and Usage Data</li>
                    </ul>
                </p>
                <h5>Usage Data</h5>
                <p>
                    We may also collect information about how the Service is accessed and used (Usage Data) This Usage
                    Data may include information such as your computer's Internet Protocol address (e.g. IP address),
                    browser type, browser version, the pages of our Service that you visit, the time and date of your
                    visit, the time spent on those pages, unique device identifiers and other diagnostic data.
                </p>
                <h5>Tracking & Cookies Data</h5>
                <p>
                    We use cookies and similar tracking technologies to track the activity on our Service and hold
                    certain information.
                </p>
                <p>
                    Cookies are files with a small amount of data which may include an anonymous unique identifier.
                    Cookies are sent to your browser from a website and stored on your device. Tracking technologies
                    also used are beacons, tags and scripts to collect and track information and to improve and analyze
                    our Service.
                </p>
                <p>
                    You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
                    However, if you do not accept cookies, you may not be able to use some portions of our Service.
                </p>
                <h4>Examples of Cookies we use: Session Cookies.</h4>
                <p>
                    <ul>
                        <li>We use Session Cookies to operate our Service.</li>
                        <li>
                            Preference Cookies. We use Preference Cookies to remember your preferences and various
                            settings.
                        </li>
                        <li>Security Cookies. We use Security Cookies for security purposes.</li>
                    </ul>
                </p>
                <h4>Use of Data:</h4>
                <p>
                    The Rocket Factory uses the collected data for various purposes:
                    <ul>
                        <li>To provide and maintain the Service</li>
                        <li>To notify you about changes to our Service</li>
                        <li>
                            To allow you to participate in interactive features of our Service when you choose to do so
                        </li>
                        <li>To provide customer care and support</li>
                        <li>To provide analysis or valuable information so that we can improve the Service</li>
                        <li>To monitor the usage of the Service</li>
                        <li>To detect, prevent and address technical issues</li>
                    </ul>
                </p>
                <h4>Transfer Of Data:</h4>
                <p>
                    Your information, including Personal Data, may be transferred to — and maintained on — computers
                    located outside of your state, province, country or other governmental jurisdiction where the data
                    protection laws may differ from those from your jurisdiction. If you are located outside Portugal
                    and choose to provide information to us, please note that we transfer the data, including Personal
                    Data, to Portugal and process it there.
                </p>
                <p>
                    Your consent to this Privacy Policy followed by your submission of such information represents your
                    agreement to that transfer.
                </p>
                <p>
                    The Rocket Factory will take all steps reasonably necessary to ensure that your data is treated
                    securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take
                    place to an organization or a country unless there are adequate controls in place including the
                    security of your data and other personal information.
                </p>
                <h4>Disclosure Of Data:</h4>
                <h5>Legal Requirements</h5>
                <p>
                    The Rocket Factory may disclose your Personal Data in the good faith belief that such action is
                    necessary to:
                    <ul>
                        <li>To comply with a legal obligation</li>
                        <li>To protect and defend the rights or property of 0xPay</li>
                        <li>To prevent or investigate possible wrongdoing in connection with the Service</li>
                        <li>To protect the personal safety of users of the Service or the public</li>
                        <li>To protect against legal liability</li>
                    </ul>
                </p>
                <h4>Security Of Data:</h4>
                <p>
                    We may employ third party companies and individuals to facilitate our Service (Service Providers),
                    to provide the Service on our behalf, to perform Service-related services or to assist us in
                    analyzing how our Service is used.
                </p>
                <p>
                    These third parties have access to your Personal Data only to perform these tasks on our behalf and
                    are obligated not to disclose or use it for any other purpose.
                </p>
                <h5>Analytics</h5>
                <p>
                    We may use third-party Service Providers to monitor and analyze the use of our Service.
                    <ul>
                        <li>Google Analytics</li>
                        <li>
                            Google Analytics is a web analytics service offered by Google that tracks and reports
                            website traffic. Google uses the data collected to track and monitor the use of our Service.
                            This data is shared with other Google services. Google may use the collected data to
                            contextualize and personalize the ads of its own advertising network.
                        </li>
                        <li>
                            You can opt-out of having made your activity on the Service available to Google Analytics by
                            installing the Google Analytics opt-out browser add-on. The add-on prevents the Google
                            Analytics JavaScript (ga.js, analytics.js and dc.js) from sharing information with Google
                            Analytics about visits activity.
                        </li>
                        <li>
                            For more information on the privacy practices of Google, please visit the Google Privacy &
                            Terms web page:{" "}
                            <a href="https://policies.google.com/privacy">https://policies.google.com/privacy</a>
                        </li>
                    </ul>
                </p>
                <h4>Links To Other Sites:</h4>
                <p>
                    Our Service may contain links to other sites that are not operated by us. If you click on a third
                    party link, you will be directed to that third party's site. We strongly advise you to review the
                    Privacy Policy of every site you visit.
                </p>
                <p>
                    We have no control over and assume no responsibility for the content, privacy policies or practices
                    of any third party sites or services.
                </p>
                <h4>Children's Privacy:</h4>
                <p>Our Service does not address anyone under the age of 18 ("Children").</p>
                <p>
                    We do not knowingly collect personally identifiable information from anyone under the age of 18. If
                    you are a parent or guardian and you are aware that your Children has provided us with Personal
                    Data, please contact us. If we become aware that we have collected Personal Data from children
                    without verification of parental consent, we take steps to remove that information from our servers.
                </p>
                <h4>Changes To This Privacy Policy:</h4>
                <p>
                    We may update our Privacy Policy from time to time. We will notify you of any changes by posting the
                    new Privacy Policy on this page.
                </p>
                <p>
                    We will let you know via email and/or a prominent notice on our Service, prior to the change
                    becoming effective and update the "effective date" at the top of this Privacy Policy.
                </p>
                <p>
                    You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy
                    Policy are effective when they are posted on this page.
                </p>
                <h5>Contact Us</h5>
                <p>
                    If you have any questions about this Privacy Policy, please contact us:
                    <ul>
                        <li>
                            By email: <a href="mailto:info@tomsachsrocketfactory.com">info@tomsachsrocketfactory.com</a>
                        </li>
                    </ul>
                </p>
            </div>
        </div>
    </Container>
);

export default Privacy;
